import { answerSheetState } from "atoms/answerSheet";
import {
  currentProblemState,
  currentStepState,
  stepTypeState,
  totalStepState,
} from "atoms/controller";
import { problemState } from "atoms/problems";
import { quizState } from "atoms/quiz";
import { userQuizState } from "atoms/userQuiz";
import { AnswerSheet, StepTypes } from "models/controller";
import { IProblem } from "models/problem";
import { IQuiz } from "models/quiz";
import { IUserQuiz } from "models/userQuiz";
import { selector } from "recoil";
import { appStrings } from "utils/appStrings";
import { toNumber } from "lodash";

export const getCurrentContent = selector<Record<string, any>>({
  key: "getCurrentContent",
  get: ({ get }) => {
    const quiz: IQuiz | undefined = get(quizState);
    const problems: IProblem[] = get(problemState);
    const currentProblem: number = get(currentProblemState);
    const answerSheet: AnswerSheet = get(answerSheetState);
    const problem = problems[currentProblem];
    const userAnswer: number = answerSheet[toNumber(problem?.id)];
    const userQuiz: IUserQuiz | undefined = get(userQuizState);
    switch (get(stepTypeState)) {
      case StepTypes.INTRO:
        return {
          description: quiz?.description,
        };
      case StepTypes.PROBLEM:
        return { ...problem, userAnswer };
      case StepTypes.ANSWER:
        const correctAnswer = problem.options.filter(
          (item) => item.is_solution === true
        );
        return {
          ...problem,
          userAnswer,
          correctAnswer: correctAnswer || [],
        };
      case StepTypes.RESULT:
        return {
          score: userQuiz?.score,
          token: userQuiz?.token,
          id: userQuiz?.id,
          schemaID: quiz?.id,
        };
      default:
        return {};
    }
  },
});

export const getProgressPercentage = selector<string>({
  key: "getProgressPercentage",
  get: ({ get }) => {
    const total = get(totalStepState);
    const current = get(currentStepState);
    return ((current / total) * 100).toFixed(1);
  },
});

export const getCurrentProblem = selector<number>({
  key: "getCurrentProblem",
  get: ({ get }) => {
    return get(currentProblemState) + 1;
  },
});

export const getNextLabel = selector<string>({
  key: "getNextTitle",
  get: ({ get }) => {
    const total = get(problemState).length;
    const current = get(currentProblemState);
    const stepType = get(stepTypeState);
    switch (stepType) {
      case StepTypes.INTRO:
        return appStrings.start;
      case StepTypes.PROBLEM:
        return appStrings.submitAnswer;
      case StepTypes.ANSWER:
        return current === total - 1 ? appStrings.showResult : appStrings.next;
      default:
        return appStrings.finish;
    }
  },
});
